'use client';

import type { ToasterProps } from 'sonner';
import { Toaster as SonnerToaster } from 'sonner';

// @ts-expect-error — sonner v2 peer-requires @types/react@18; runtime-compatible with React 19
const Toaster = (props: ToasterProps) => <SonnerToaster {...props} />;

export default Toaster;
